import React, { useState } from "react";
import { legalDisclaimerApi, SocialLogin } from "../../../api/user";
import { legalAcceptedFlag } from "../../../utils/legalAcceptance";
import { onboardingPathForSignup } from "../../../utils/onboardingMeasurement";
import { setPendingSignupEmail } from "../../../utils/pendingSignup";
import { useGoogleLogin } from "@react-oauth/google";
import "./Login.css";
import googleImg from "../../../images/Google.png";
import { sendEvent } from "../../../utils/event";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LegalPopupModal from "../../../components/Modals/legalDisclaimer";
import { setSidebarCollapseOverride } from "../../../utils/sidebarCollapse";

// Existing social-login refusals from the backend (lang/en/message.php).
const SOCIAL_LOGIN_ERRORS = {
  "This email ID is linked to another account. Please contact the support team for assistance.":
    "An account with this email already exists. Log in the way you signed up, or contact support.",
  "This phone number is linked to another account. Please contact the support team for assistance.":
    "An account with this phone number already exists. Log in the way you signed up, or contact support.",
  "Please confirm your agreement and age eligibility to continue.":
    "Confirm the Terms of Service, Privacy Policy, and age requirement.",
};
const socialLoginError = (message) =>
  SOCIAL_LOGIN_ERRORS[message] ||
  "Could not log in. Check your information and try again.";

const GoogleButton = () => {
  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);

  const responseMessage = (response) => {
    if (!response?.access_token) {
      setLoader(false);
      return;
    }
    setLoader(true);
    localStorage.setItem("aaaa", response.access_token);
    getTokenInfo(response.access_token);
  };

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  const handleClose = () => {
    navigate("/profile");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  const handleLegalPopup = async () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status === 200) {
        setShowPopUp(false);
        if (userInfo?.user_name) {
          navigate("/profile");
        } else {
          navigate("/edit-profile");
        }
        localStorage.setItem("checkDisclaimer", false);
      }
    } catch (err) {}
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => responseMessage(codeResponse),
    onError: () => {
      setLoader(false);
      toast.error("Could not log in with Google. Try again.");
    },
    onNonOAuthError: () => {
      setLoader(false);
    },
  });

  const getTokenInfo = async (token) => {
    try {
      const response = await fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${encodeURIComponent(
          token,
        )}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (!data?.sub) {
        setLoader(false);
        return;
      }
      const socialData = {
        social_id: data?.sub,
        email: data?.email,
        first_name: data?.given_name,
        last_name: data?.family_name,
        type: 2,
        social_type: 2,
        // Only consulted when this call CREATES an account. An existing user
        // signing in is unaffected, so the sign-in screen keeps working with no
        // checkbox of its own.
        legal_accepted: legalAcceptedFlag(),
        // Measurement Core §6.2, saved on the account only when this creates it.
        onboarding_path: onboardingPathForSignup(),
      };

      setPendingSignupEmail(socialData.email);
      LoginUser(socialData);
    } catch (error) {
      console.error("Error fetching token info:", error.message);
      setLoader(false);
      toast.error("Could not log in with Google. Try again.");
    }
  };

  const navigate = useNavigate();

  const LoginUser = (data) => {
    SocialLogin(data)
      .then((response) => {
        if (response?.data?.status === 200) {
          if (response?.data?.data?.disclaimer === false) {
            setShowPopUp(true);
            localStorage.setItem("checkDisclaimer", true);
          } else {
            navigate("/profile");
          }
          localStorage.setItem("user_id", response.data.data.id);
          const token = response?.data?.data?.access_token;
          localStorage.setItem(
            "isVerified",
            response?.data?.data?.is_otp_verified,
          );
          localStorage.setItem("google_login", "1");
          localStorage.setItem("img", response?.data?.data?.image);
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response?.data?.data),
          );
          localStorage.setItem("accessToken", JSON.stringify(token));
          setSidebarCollapseOverride(null);
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(socialLoginError(response?.data?.message));
        }
      })
      .catch((error) => {
        setLoader(false);
        toast.error(socialLoginError(error?.response?.data?.message));
      });
  };

  return (
    <>
      <div className="googleLoginButton" style={{ width: "100%" }}>
        <button
          disabled={loader}
          aria-busy={loader ? "true" : undefined}
          onClick={() => {
            if (loader) return;
            login();
            sendEvent("Googlee");
          }}
          className="mt-1 secondary-button text-black px-4 items-center !justify-center flex h-11 border border-gray-300"
        >
          <img
            src={googleImg}
            className=" w-7 inline-block mx-1"
            alt="Google-logo"
          />
          <span className="">
            {loader ? "Signing in" : "Continue With Google"}
          </span>
        </button>
      </div>
      <LegalPopupModal
        isOpen={showPopup}
        handleLegalPopup={handleLegalPopup}
        checked={checked}
        handleClose={handleClose}
        handleCheckboxChange1={handleCheckboxChange1}
      />
    </>
  );
};

export default GoogleButton;
